import javaBackendAxios from "../axios"

export const getCaseInfoById = async (caseId: string) => {
    try {
        return await javaBackendAxios.get(`/api/java/case/${caseId}`);
    } catch (error) {
        console.error("Błąd podczas pobierania plików:", error);
        throw error;
    }
};
export const createCase = async (name: string, description: string, isTemp: boolean) => {
    try {
        const response = await javaBackendAxios.post('/api/java/case', {
            name: name,
            description: description,
            isTempCase: isTemp
        });
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas tworzenia sprawy", error);
        throw error;
    }
};
export const editCase = async (id: string, name: string, description: string, isTemp: boolean) => {
    try {
        const response = await javaBackendAxios.put(`/api/java/case/${id}`, {
            name: name,
            description: description,
            isTempCase: isTemp
        });
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas edycji sprawy", error);
        throw error;
    }
};
export const deleteCase = async (id: string) => {
    try {
        const response = await javaBackendAxios.delete(`/api/java/case/${id}`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas usuwania sprawy", error);
        throw error;
    }
};
export const getCaseList = async () => {
    try {
        const response = await javaBackendAxios.get('/api/java/case');
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas pobierania listy spraw:", error);
        throw error;
    }
};
export const getTempCaseInfo = async (caseId: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/case/temp/${caseId}`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas pobierania sprawy tymczasowej:", error);
        throw error;
    }
};
export const refreshTempCase = async (caseId: string) => {
    try {
        const response = await javaBackendAxios.post(`/api/java/case/temp/${caseId}`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas odswiezania czasu sprawy tymczasowej", error);
        throw error;
    }
};

export const promoteTempCase = async (caseId: string) => {
    try {
        return javaBackendAxios.put(`/api/java/case/promote/${caseId}`);
    } catch (error) {
        console.error("Błąd podczas konwersji sprawy tymczasowej na zwykla", error);
        throw error;
    }
};
export const getCaseListBySearchBar = async (searchTerm: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/case/search?query=${encodeURIComponent(searchTerm)}`);
        return await response.data;
    } catch (error) {
        console.error("Błąd podczas pobierania listy spraw:", error);
        throw error;
    }
};
export const checkCaseNameIsUnique = async (caseName: string) => {
    try {
        const response = await javaBackendAxios.get(`/api/java/case/unique?case-name=${encodeURIComponent(caseName)}`);
        return response.status === 200;
    } catch (error) {
        throw error;
    }
};